import { HFlow } from 'bold-ui'
import { useBuscaCidadaoCabecalhoQuery } from 'graphql/hooks.generated'
import React from 'react'
import {
  InformacoesCadastrais,
  InformacoesCadastraisSimplificadas,
} from 'view/cidadao/visualizacao/CidadaoCabecalhoSection'

export interface AtendimentoCidadaoHeaderProps {
  cidadaoId: ID
  minimizado?: boolean
}

export function AtendimentoCidadaoHeader(props: AtendimentoCidadaoHeaderProps) {
  const { cidadaoId, minimizado } = props
  const { data } = useBuscaCidadaoCabecalhoQuery({ variables: { id: cidadaoId } })

  return (
    <>
      {data?.cidadao && (
        <HFlow alignItems='flex-start' hSpacing={0.5} justifyContent='space-between' style={{ marginTop: '1rem' }}>
          {minimizado ? (
            <InformacoesCadastraisSimplificadas cidadao={data.cidadao} />
          ) : (
            <InformacoesCadastrais cidadao={data.cidadao} />
          )}
        </HFlow>
      )}
    </>
  )
}
